// The first partner link followed in this browser. The API sets a cookie too, but when it lives on
// another origin (dev.* and api-dev.*) the browser drops it, so the value is kept here and sent back
// in a header with every request.
const REF_KEY = 'mq_ref';

export const getStoredRef = () => {
  try {
    return localStorage.getItem(REF_KEY) || '';
  } catch (e) {
    return '';
  }
};

export const storeRef = (value) => {
  try {
    if (value && !localStorage.getItem(REF_KEY)) localStorage.setItem(REF_KEY, value);
  } catch (e) {
    // private mode: the cookie still works where the API shares the origin
  }
};
